const Sentry = require('@sentry/gatsby');

Sentry.init({
  dsn: 'https://9bb8b68b17664a258e1e3c9683d813a9@o4503999131877376.ingest.us.sentry.io/4503999224610816',
  // no IP addresses, cookies or user details in error reports (privacy policy)
  sendDefaultPii: false,
  enableLogs: false,
});
